"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Account from "../api/account";
import { Flash } from "../components/flash";
function isVisible(props, state) {
  return state.visible && props.loggedIn && props.currentUser && props.currentUser.internal;
}
function accountAdminHref(props) {
  return "/admin/accounts/" + props.currentUser.account.id;
}
function accountName(props) {
  return props.currentUser.account.name;
}
function accountTooltip(props) {
  const account = props.currentUser.account;
  return `Id: ${account.id}
Alias: ${account.alias}
TMS: ${account.tms}`;
}
function getLocation(state) {
  const windowLocation = getWindowLocation(state);
  return {
    pathname: windowLocation.pathname,
    query: Object.fromEntries(new URLSearchParams(windowLocation.search))
  };
}
function getWindowLocation(state) {
  if (state.windowLocation) {
    return state.windowLocation;
  } else {
    return window.location;
  }
}
function possibleResourceLinks(state) {
  const adminResources = [];
  const location = getLocation(state);
  function extractIdRoute(routePrefix, adminResource, entityName) {
    const regex = new RegExp(routePrefix + "\\/(\\d+)");
    const match = location.pathname.match(regex);
    if (match) {
      adminResources.push({
        href: "/admin/" + adminResource + "/" + match[1],
        text: entityName
      });
      return true;
    }
  }
  if (!extractIdRoute("email", "email_messages", "Email")) {
    const emailId = location.query["emailId"];
    if (emailId) {
      adminResources.push({
        href: "/admin/email_messages/" + emailId,
        text: "Email Message"
      });
    }
  }
  extractIdRoute(
    "index-document-batches",
    "document_batches",
    "Document Batch"
  );
  extractIdRoute("loads", "load_states", "LoadState");
  extractIdRoute("carrier_invoices", "carrier_invoices", "Invoice");
  extractIdRoute(
    "carrier_invoices_workflow",
    "carrier_invoices",
    "Carrier Invoice"
  );
  extractIdRoute("factor_invoices", "factor_invoices", "Invoice");
  extractIdRoute(
    "factor_invoices_workflow/batch",
    "document_batches",
    "Document Batch"
  );
  extractIdRoute(
    "factor_invoices_workflow",
    "factor_invoices",
    "Factor Invoice"
  );
  extractIdRoute("customers", "tms_customers", "Customer");
  extractIdRoute(
    "customer_invoicing/invoices",
    "customer_invoices",
    "Customer Invoice"
  );
  extractIdRoute(
    "client_submission/email/\\d+/invoice",
    "factor_invoices",
    "Factor Invoice"
  );
  return adminResources.map((r) => {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: r.href, target: "_blank", children: r.text }) }, r.href);
  });
}
function environmentUrls(props, state) {
  const hosts = Account.current().environment_urls || {};
  return [
    {
      name: "Staging",
      host: hosts.staging
    },
    {
      name: "Prod",
      host: hosts.production
    }
  ].filter((env) => {
    return env.host && getWindowLocation(state).origin != env.host;
  }).map((env) => {
    const accountAlias = props.currentUser.account.alias;
    const loginUrl = `${env.host}/l/${accountAlias}`;
    const pageUrl = `${env.host}${getWindowLocation(state).pathname}${getWindowLocation(state).search}`;
    return __spreadProps(__spreadValues({}, env), {
      loginUrl,
      pageUrl
    });
  });
}
function reskinToggle(props) {
  const visible = props.toggleReskin && props.currentUser.admin && !props.currentUser.managed_indexer;
  const defaultValue = props.reskinToggleVal || "default";
  if (visible) {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
      "label",
      {
        title: "Apply reskin styles for all pages. This only affects your experience and does not affect other users.",
        style: {
          color: "white",
          display: "flex",
          gap: "6px",
          whiteSpace: "nowrap",
          fontSize: "13px"
        },
        children: [
          "V3 Reskin",
          /* @__PURE__ */ jsxs(
            "select",
            {
              onChange: props.toggleReskin,
              style: {
                height: "unset",
                margin: "0",
                padding: "2px 24px 0 8px",
                borderRadius: "4px",
                fontSize: "13px"
              },
              value: defaultValue,
              children: [
                /* @__PURE__ */ jsx("option", { value: "default", children: "Use account settings" }),
                /* @__PURE__ */ jsx("option", { value: "on", children: "Always on" }),
                /* @__PURE__ */ jsx("option", { value: "off", children: "Always off" })
              ]
            }
          )
        ]
      }
    ) });
  }
}
function copyShareableLinksToClipboard(props, state) {
  return __async(this, null, function* () {
    const accountAlias = props.currentUser.account.alias;
    const siteUrl = getWindowLocation(state).origin;
    const signInAsUrl = `${siteUrl}/l/${accountAlias}`;
    const currentPageUrl = getWindowLocation(state).href;
    const shareableLink = `${signInAsUrl}?next=${currentPageUrl}`;
    try {
      yield navigator.clipboard.writeText(shareableLink);
      Flash.success(`Copied shareable page link: ${shareableLink}`);
    } catch (e) {
      Flash.alert("Failed to copy to clipboard");
    }
  });
}
function copyAccountAliasToClipboard(props) {
  return __async(this, null, function* () {
    const accountAlias = props.currentUser.account.alias;
    if (!accountAlias) {
      Flash.alert("Failed to copy to clipboard");
      return;
    }
    try {
      yield navigator.clipboard.writeText(accountAlias);
      Flash.success(`Copied account alias: ${accountAlias}`);
    } catch (e) {
      Flash.alert("Failed to copy to clipboard");
    }
  });
}
class StaffBar extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "interval");
    __publicField(this, "hideStaffBar", () => {
      this.setState({ visible: false });
    });
    // Called on the instance through App's staffBar ref when Elm changes the URL.
    __publicField(this, "refreshLocation", () => {
      this.forceUpdate();
    });
    const initialState = {
      visible: true
    };
    if (props.useIntervalReloader) {
      initialState.windowLocation = window.location;
    }
    this.state = initialState;
  }
  componentDidMount() {
    if (this.props.useIntervalReloader) {
      this.interval = setInterval(() => {
        this.setState({
          windowLocation: window.location
        });
      }, 500);
    }
  }
  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  render() {
    if (isVisible(this.props, this.state)) {
      return /* @__PURE__ */ jsx("div", { "data-component": "StaffBar", className: "staff-bar-container", children: /* @__PURE__ */ jsx("nav", { className: "staff-bar", children: /* @__PURE__ */ jsxs("ul", { children: [
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          "span",
          {
            className: "staff-bar-header",
            "data-tooltip": true,
            "aria-haspopup": "true",
            title: "The Staff Bar is only seen by internal users",
            children: "Staff Bar"
          }
        ) }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          "a",
          {
            onClick: this.hideStaffBar,
            title: "Hide the Staff Bar until the page is refreshed. Useful for taking screenshots.",
            children: "Hide"
          }
        ) }),
        /* @__PURE__ */ jsxs("li", { children: [
          "Share Page",
          /* @__PURE__ */ jsx(
            "a",
            {
              className: "icon-copy",
              onClick: () => copyShareableLinksToClipboard(this.props, this.state)
            }
          )
        ] }),
        /* @__PURE__ */ jsx("li", { children: "|" }),
        /* @__PURE__ */ jsx(
          "li",
          {
            title: accountTooltip(this.props),
            onClick: () => copyAccountAliasToClipboard(this.props),
            style: { cursor: "pointer" },
            children: accountName(this.props)
          }
        ),
        /* @__PURE__ */ jsx("li", { children: "|" }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("b", { children: "Admin Pages:" }) }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/admin", children: "Dashboard" }) }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: accountAdminHref(this.props), target: "_blank", children: "Account" }) }),
        possibleResourceLinks(this.state),
        (this.props.extraAdminLinks || []).map((link) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: link.href, target: "_blank", children: link.text }) }, link.href)),
        environmentUrls(this.props, this.state).map((env) => /* @__PURE__ */ jsxs(React.Fragment, { children: [
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs("b", { children: [
            env.name,
            ":"
          ] }) }),
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: env.loginUrl, target: "_blank", children: "Login" }) }),
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: env.pageUrl, target: "_blank", children: "Page" }) })
        ] }, env.name)),
        reskinToggle(this.props)
      ] }) }) });
    } else {
      return /* @__PURE__ */ jsx("div", {});
    }
  }
}
export default StaffBar;
